import { useForm } from '@mantine/form';
import {
  Button,
  Group,
  Checkbox,
  TextInput,
  Stack,
  Modal,
} from '@mantine/core';
import type { SupportStoreType } from '../../../models/partner.ts';

export interface CreatePartnerForm {
  name: string;
  displayNameForHuman?: string;
  supportStoreTypes: SupportStoreType[];
}

interface CreatePartnerModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: ({ formValues }: { formValues: CreatePartnerForm }) => void;
  isPending: boolean;
}

export default function CreatePartnerModal({
  opened,
  onClose,
  onConfirm,
  isPending,
}: CreatePartnerModalProps) {
  const form = useForm<CreatePartnerForm>({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      displayNameForHuman: '',
      supportStoreTypes: [],
    },
    validate: {
      name: (value) => (value ? null : ' '),
      supportStoreTypes: (value) =>
        value.length > 0 ? null : '請選擇可管理場站類型',
    },
  });

  const checkBoxStyle = form.errors.supportStoreTypes
    ? {
        input: { borderColor: 'var(--mantine-color-red-6)' },
        label: { color: 'var(--mantine-color-red-6)' },
      }
    : undefined;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="新增業者"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack>
        <form
          onSubmit={form.onSubmit((values: CreatePartnerForm) =>
            onConfirm({ formValues: values }),
          )}
        >
          <TextInput
            withAsterisk
            label="業者名稱"
            placeholder="請輸入業者名稱"
            key={form.key('name')}
            {...form.getInputProps('name')}
          />
          <TextInput
            mt="md"
            label="前台顯示名稱"
            placeholder="請輸入前台顯示名稱"
            key={form.key('displayNameForHuman')}
            {...form.getInputProps('displayNameForHuman')}
          />
          <Checkbox.Group
            mt="md"
            withAsterisk
            label="可管理場站類型"
            {...form.getInputProps('supportStoreTypes')}
            styles={{
              error: { marginTop: 10 },
            }}
          >
            <Group>
              <Checkbox
                value="Parkinglot"
                label="停車場"
                styles={checkBoxStyle}
              />
              <Checkbox
                value="GasStation"
                label="加油站"
                styles={checkBoxStyle}
              />
              <Checkbox
                value="ChainStore"
                label="連鎖店"
                styles={checkBoxStyle}
              />
            </Group>
          </Checkbox.Group>
          <Group justify="flex-end" mt="md">
            <Button type="button" onClick={onClose} variant="outline" fw={400}>
              取消
            </Button>
            <Button type="submit" loading={isPending} fw={400}>
              新增
            </Button>
          </Group>
        </form>
      </Stack>
    </Modal>
  );
}
